// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TrakingInfo {
    flex-direction: row;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-wrap: wrap;
  }
  
  /* Für kleine Bildschirme (z.B. Mobiltelefone) */
  @media (max-width: 600px) {
    .TrakingCard {
      flex: 1 1 100%;
    }
    .TrakingCardÜberschrift {
        font-size: 25px;
      }
  }
  
  /* Für mittlere Bildschirme (z.B. Tablets) */
  @media (min-width: 601px) and (max-width: 1024px) {
    .TrakingCard {
      flex: 1 1 50%;
    }
  }
  
  .TrakingCardIcon {
    justify-content: right;
  }
  
  .TrakingCardZahlen {
    font-size: 30px;
    justify-content: left;
  }
  
  .TrakingCardInfo {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 10px;
  }
  
  /* Stile für die Besucher-Karte */
  .TrakingCard:nth-child(1) {
    background-color: #f0f0f0;
  }
  
  .TrakingCard:nth-child(1) .TrakingCardIcon {
    color: #333;
  }
  
  /* Stile für die Reservierungen-Karte */
  .TrakingCard:nth-child(2) {
    background-color: #f0e5ff;
  }
  
  .TrakingCard:nth-child(2) .TrakingCardIcon {
    color: #6b5be2;
  }
  
  /* Stile für die Instagram-Karte */
  .TrakingCard:nth-child(3) {
    background-color: #ffe0e6;
  }
  
  .TrakingCard:nth-child(3) .TrakingCardIcon {
    color: #E1306C;
  }
  `, "",{"version":3,"sources":["webpack://./src/container/Dashboard/components/Tracking/tracking.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,eAAe;EACjB;;EAEA,gDAAgD;EAChD;IACE;MACE,cAAc;IAChB;IACA;QACI,eAAe;MACjB;EACJ;;EAEA,4CAA4C;EAC5C;IACE;MACE,aAAa;IACf;EACF;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA,iCAAiC;EACjC;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;EACb;;EAEA,uCAAuC;EACvC;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA,kCAAkC;EAClC;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB","sourcesContent":[".TrakingInfo {\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    display: flex;\n    flex-wrap: wrap;\n  }\n  \n  /* Für kleine Bildschirme (z.B. Mobiltelefone) */\n  @media (max-width: 600px) {\n    .TrakingCard {\n      flex: 1 1 100%;\n    }\n    .TrakingCardÜberschrift {\n        font-size: 25px;\n      }\n  }\n  \n  /* Für mittlere Bildschirme (z.B. Tablets) */\n  @media (min-width: 601px) and (max-width: 1024px) {\n    .TrakingCard {\n      flex: 1 1 50%;\n    }\n  }\n  \n  .TrakingCardIcon {\n    justify-content: right;\n  }\n  \n  .TrakingCardZahlen {\n    font-size: 30px;\n    justify-content: left;\n  }\n  \n  .TrakingCardInfo {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-top: 10px;\n  }\n  \n  /* Stile für die Besucher-Karte */\n  .TrakingCard:nth-child(1) {\n    background-color: #f0f0f0;\n  }\n  \n  .TrakingCard:nth-child(1) .TrakingCardIcon {\n    color: #333;\n  }\n  \n  /* Stile für die Reservierungen-Karte */\n  .TrakingCard:nth-child(2) {\n    background-color: #f0e5ff;\n  }\n  \n  .TrakingCard:nth-child(2) .TrakingCardIcon {\n    color: #6b5be2;\n  }\n  \n  /* Stile für die Instagram-Karte */\n  .TrakingCard:nth-child(3) {\n    background-color: #ffe0e6;\n  }\n  \n  .TrakingCard:nth-child(3) .TrakingCardIcon {\n    color: #E1306C;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
